import React, { useContext, useEffect, useState } from 'react';
import { API, Auth } from 'aws-amplify';
import AppContext from '../../AppContext';
import Q4BizSidebar from '../Q4BizEmbedding/QBizSidebar';
import CustomDropdown from '../Dropdown/CustomDropdown';

// import Select from 'react-select';

const QuickSightDashboard2 = ({ dashboardId, dashboardTitle, dashboardType, dashboardSubtype, apiKey, realTime, embedContext, classes, singleSheet = false }) => {
    
  // const [loading, setLoading] = useState(true);
  const { dashboard, setDashboard, showWlsLogo } = useContext(AppContext);
  const [ selectedPivotRows, setSelectedPivotRows] = useState([]);
  const [ selectedPivotColumns, setSelectedPivotColumns] = useState([]);
  const [ selectedPivotMetric, setSelectedPivotMetric] = useState([]);
  const [ pivotTableLoaded, setPivotTableLoaded ] = useState(dashboardSubtype === 'pivot' ? false : true)
  const [ errorBanner, setErrorBanner] = useState('')
  const [embedError, setEmbedError] = useState('');




//   const ImgStyled = styled.img`
//   height: 25px;
//   z-index: 9999999;
//   margin: 10px;
//   display: block;
//   top: 0 px;
//   position: relative;
// `

    const rowsAndColumns = ['Region', 'Country', 'Industry', 'Product', 'Customer', 'Contact Name', 'Order Date Week', 'Order Date Month', 'Order ID']
    const rowOptions = rowsAndColumns.filter(field => !selectedPivotColumns.includes(field));
    const columnOptions = rowsAndColumns.filter(field => !selectedPivotRows.includes(field));
    const metricOptions = ['Discount', 'Sales', 'Profit', 'Quantity']
    const specialOptions = {
        'Discount': ['Sum', 'Average'],
        'Sales': ['Sum', 'Average'],
        'Profit': ['Sum', 'Average'],
        'Quantity': ['Sum', 'Average']
      };
    const validPivotCombinations = [
        [2, 3, 2], // Rows, Columns, Metrics
        [3, 3, 2],
        [3, 2, 2],
        [4, 2, 2],
        [4, 1, 2]
    ]


  useEffect(() => {
    if(!!dashboardTitle) {
      document.title = dashboardTitle
    } 
  }, [dashboardTitle])

//   useEffect(() => {
//     let timer;
//     if(realTime && dashboard) {
//       timer = setTimeout(() => {
//         dashboard.setParameters([{'Name': "refreshParameter", 'Values': Date.now()}]);
//         // console.log('asdlfkjslkfdjs')
//       }, 5000);

//     }
//     return () => { clearTimeout(timer) };
//   },[realTime, dashboard])


  const getDashboardUrl = async (params = []) => {
    setEmbedError('');
    try {

      let url;
      let headers;
      // let singleSheet = false;
      const anonymous = import.meta.env.VITE_ANONYMOUS === 'true' || !!apiKey;
      if(anonymous && dashboardType?.toLowerCase() === 'topic') {
        url = 'get-anonymous-quicksight-q-url?topic_id';
        headers = apiKey ? { 'X-API-Key': apiKey } : {}
      } else if (anonymous) {
        url = 'get-anonymous-quicksight-url?dashboard_id';
        headers = apiKey ? { 'X-API-Key': apiKey } : {}
        // singleSheet = true;
      } else if(dashboardType?.toLowerCase() === 'topic') {
        url='get-quicksight-q-url?topic_id'
        headers = { Authorization: await Auth.currentSession().then(data => data.getIdToken().getJwtToken()) }
      } else {
        url='get-quicksight-url?dashboard_id'
        headers = { Authorization: await Auth.currentSession().then(data => data.getIdToken().getJwtToken()) }
      }
      try {
        const response = await API.get('APIEndpoint', `/${url}=${dashboardId}&hostname=${window.location.origin}`, {response: true, headers: headers}) 

        if(response?.data?.url) {
          const { embedDashboard, embedGenerativeQnA } = embedContext;
          const frameOptions = {
              url: response.data.url,
              container: document.getElementById(dashboardId),
              height: "100%",
              width: "100%",
              // onChange: ((e,d) => {console.log('frameoptions onChange',e,d)}),
              // onMessage: ((e,d) => {console.log('frameoptions onMessage',e,d)}),

          };
          const contentOptions = {
              parameters: params.push({'Name': "URL", 'Values': [window.location.host]}),
              toolbarOptions: {
                  export: false,
                  undoRedo: false,
                  reset: false,
                  bookmarks:false
              },
              sheetOptions: {
              //     initialSheetId: '<YOUR_SHEETID>',
                  singleSheet: dashboardSubtype === 'pivot' ? true : singleSheet,                        
              //     emitSizeChangedEventOnSheetChange: false,
              },
              attributionOptions: {
                  overlayContent: false,
              },
            //   onMessage: async (messageEvent, experienceMetadata) => {
            //       // console.log('messageEvent, experienceMetadata', messageEvent, experienceMetadata)
            //       switch (messageEvent.eventName) {
            //           case 'CONTENT_LOADED': {
            //               console.log("All visuals are loaded. The title of the document:", messageEvent.message.title);
            //               // setLoading(false)
            //               // break;
            //           }
            //           // case 'ERROR_OCCURRED': {
            //           //     console.log("Error occurred while rendering the experience. Error code:", messageEvent.message.errorCode);
            //           //     break;
            //           // }
            //           case 'PARAMETERS_CHANGED': {
            //               console.log("Parameters changed. Changed parameters:", messageEvent);
            //               // setNumberOfParameterChanges(x => x + 1);
            //               // if(messageEvent?.message?.changedParameters[0]?.Name === 'FState') {
            //               //     setResetCity(x => x + 1);
            //               //     // setResetNpi(x => x + 1);
            //               // }
            //               // if(messageEvent?.message?.changedParameters[0]?.Name === 'FCity') {
            //               //     setResetNpi(x => x + 1);
            //               // }
            //               // const params = await dashboard.getParameters()
            //               // setGlobalParameters(params);
            //               break;
            //           }
            //           case 'SELECTED_SHEET_CHANGED': {
            //               console.log("Selected sheet changed. Selected sheet:", messageEvent.message.selectedSheet);
            //               // setActiveSheet(messageEvent?.message?.selectedSheet?.SheetId)
            //               break;
            //           }
            //           // case 'SIZE_CHANGED': {
            //           //     console.log("Size changed. New dimensions:", messageEvent.message);
            //           //     break;
            //           // }
            //           // case 'MODAL_OPENED': {
            //           //     window.scrollTo({
            //           //         top: 0 // iframe top position
            //           //     });
            //           //     break;
            //           // }

            //           default:
            //       }
            //   },

          };

          if (dashboardType?.toLowerCase() === 'topic') {
            setDashboard(await embedGenerativeQnA(frameOptions, contentOptions))
          } else {
            setDashboard(await embedDashboard(frameOptions, contentOptions))
          }

          // setLoading(false);

        } else {

        } 
      } catch (err) {
        setEmbedError('Unable to load this dashboard. The dashboard embedding service is unavailable or not configured for this site.');
        console.log('err: ', err)
      }

    
    } catch(error) {
      setEmbedError('Unable to load this dashboard. The dashboard embedding service is unavailable or not configured for this site.');
      
      if(API.isCancel(error)) {
        // "my message for cancellation"
        console.log(error.message);
        // handle user cancellation logic
      }
        console.log(error)
        // setLoading(false);
        // setFailureMessage('There was an issue loading your dashboard. Please contact your administrator.');
    }
  }

  
  useEffect(() => {
      
    

    // if (dashboardId && embedContext && dashboardSubtype !== 'pivot') {
    
    if (dashboardId && embedContext) {
        setDashboard();
        // setLoading(true);
        getDashboardUrl();
    }

    // return () => API.cancel(response, "my message for cancellation");
    // eslint-disable-next-line 
  },[dashboardId, embedContext, apiKey, dashboardType])

  

//   const handleOptionChange = (event) => {
//     const selectedValues = Array.from(event.target.selectedOptions, option => option.value);
//     setSelectedValues selectedValues;
//   };
    const validatePivotSelection = (rows, columns, metrics) => {
        const currentCombination = [rows.length, columns.length, metrics.length]

        const isValid = validPivotCombinations.some(
            ([validRows, validColumns, validMetrics]) =>
            validRows === currentCombination[0] &&
            validColumns === currentCombination[1] &&
            validMetrics === currentCombination[2]
        )

        if (!isValid) {
            const validOptionsText = validPivotCombinations
            .map(([r, c, m]) => `Rows: ${r}, Columns: ${c}, Metrics: ${m}`)
            .join(' | ')

            return `Invalid selection. 
        Please adjust your selection to match one of the following allowed combinations:
        ${validOptionsText}`
        }

        return null
    }

    const preparePivotParams = () => {
        let params = [];
        selectedPivotRows.forEach((row, index) => {
            params.push({ Name: `RowField${index + 1}`, Values: [row] })
        })

        selectedPivotColumns.forEach((column, index) => {
            params.push({ Name: `ColumnField${index + 1}`, Values: [column] })
        })

        selectedPivotMetric.forEach((metric, index) => {
        params.push({ Name: `MetricField${index + 1}`, Values: [metric] })
        })

        const pluralize = (count, word) => `${count} ${word}${count === 1 ? '' : 's'}`
        params.push({
            Name: 'TableType',
            Values: [`${pluralize(selectedPivotRows.length, 'Row')} ${pluralize(selectedPivotColumns.length, 'Column')} ${pluralize(selectedPivotMetric.length, 'Metric')}`]
        })
        return params;
    }

    const loadPivotTable = () => {
        const errorMessage = validatePivotSelection(selectedPivotRows, selectedPivotColumns, selectedPivotMetric)

        if (errorMessage) {
            console.log('Invalid selection: ', errorMessage)
            setErrorBanner(errorMessage)
        } else {
            // setDashboard();
            setErrorBanner('')
            setPivotTableLoaded(true);
            // const params = [
            //     { 'Name': 'Rows', 'Values': selectedPivotRows },
            //     { 'Name': 'Columns', 'Values': selectedPivotColumns },
            //     { 'Name': 'Metrics', 'Values': selectedPivotMetric },
            //     { 'Name': 'Type', 'Values': `${selectedPivotRows.length} Rows ${selectedPivotColumns.length} Columns ${selectedPivotMetric.length} Metrics` }
            //   ]
            const params = preparePivotParams(selectedPivotRows, selectedPivotColumns, selectedPivotMetric)
            console.log('params:  ', params)
            // await getDashboardUrl(params);
            dashboard.setParameters(params);
        }
    }

    
  return (
  <>
    {embedError && <p role="alert" className="m-4 rounded-md bg-red-100 p-3 text-red-700">{embedError}</p>}
    {dashboardSubtype !== '' &&
    <div className="w-full max-h-96 p-4 bg-gray-100 rounded-lg">
        
        {errorBanner && (
        <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg text-sm font-poppins shadow">
            {errorBanner}
        </div>
        )}
    
        <div className="flex items-center gap-4 w-full">
            <CustomDropdown options={rowOptions} selectedOptions={selectedPivotRows} setSelectedOptions={setSelectedPivotRows} dropDownName="Rows" placeholder="" />
            <CustomDropdown options={columnOptions} selectedOptions={selectedPivotColumns} setSelectedOptions={setSelectedPivotColumns} dropDownName="Columns" placeholder=""  />
            <CustomDropdown options={metricOptions} selectedOptions={selectedPivotMetric} setSelectedOptions={setSelectedPivotMetric} dropDownName="Metrics" placeholder="" specialOptions={specialOptions} />
            {/* <button
                className="min-h-[45px] px-4 bg-blue-500 hover:bg-blue-600 text-white text-sm font-poppins rounded-md shadow-md transition duration-300 self-end"
                onClick={loadPivotTable}
                >
                Apply
            </button> */}
            <button className="h-[40px] px-4 bg-blue-500 hover:bg-blue-600 text-white font-semibold text-sm rounded-md flex items-center self-end justify-center whitespace-nowrap transition-colors duration-200">
  Apply
</button>

        </div>
    </div>}
  <div className={classes ? classes : 'flex flex-1 h-full'} >
  
    <><div 
      key={dashboardId}
      id={dashboardId}
      className="dashboardContainer flex w-full relative" //position: "absolute", , maxHeight: "92vh"  
      style={{position: 'relative'}}
    />
    {showWlsLogo &&<div style={{position: 'absolute', bottom: 0, right: 0}}>
      <a href='https://www.westloop.io' alt='Westloop Strategy Home'>
        <img alt='wls' src='/wls_logo.svg' className='logo'/>
      </a>
    </div>}

    {import.meta.env.VITE_SSO === "true" && <Q4BizSidebar/>}
    </>
  </div>
  </>);
}

export default QuickSightDashboard2;